import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { CortevaParticipant } from 'src/app/core/journey-core/journey.interface';

@Injectable({
  providedIn: 'root'
})
export class CortevaDBService {
  private apiUrl = `${environment.serverUrl}/genie-corteva`;

  constructor(private http: HttpClient) {}

  getParticipants(limit: number = 100, offset: number = 0): Observable<CortevaParticipant[]> {
    let params = new HttpParams()
      .set('limit', limit.toString())
      .set('offset', offset.toString());

    return this.http.get<CortevaParticipant[]>(this.apiUrl, { params });
  }

  // Note: API returns search results, assuming it returns an array of participants
  searchParticipants(email: string): Observable<CortevaParticipant[]> {
    let params = new HttpParams().set('email', email);
    return this.http.get<CortevaParticipant[]>(`${this.apiUrl}/search`, { params });
  }

  uploadParticipants(file: File, companyId: string): Observable<any> {
    const formData = new FormData();
    formData.append('file', file);
    
    // Note: The curl command has companyId as a query parameter in the URL
    // URL: https://staging.adminv2.talentlitmus.com/genie-corteva?companyId=...
    let params = new HttpParams().set('companyId', companyId);

    return this.http.post(this.apiUrl, formData, { 
      params,
      reportProgress: true,
      observe: 'events'
    });
  }

  updateParticipant(participant: Partial<CortevaParticipant>): Observable<any> {
    // Strictly following the curl command payload structure
    // companyId is NOT in the payload
    const payload = {
      _id: participant._id,
      email: participant.email,
      designation: participant.designation,
      mobileNumber: participant.mobileNumber,
      name: participant.name,
      reportingManagerName: participant.reportingManagerName,
      state: participant.state,
      territory: participant.territory,
      zone: participant.cuZone // Mapping cuZone to zone as per curl body "zone"
    };
    return this.http.patch(this.apiUrl, payload);
  }

  deleteParticipant(id: string, email: string): Observable<any> {
    const body = { _id: id, email: email };
    return this.http.delete(this.apiUrl, { body });
  }
}
